/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import networkManager from "../network";

export async function fetchDocument(location: string) {
  const network = networkManager.create();
  const response = await network.get(location);
  return response;
}
